/**
 * Company Statistics
 *
 * @component companystatistics
 */

import ClassLogger from 'ClassLogger';
import Api from './_api.js';

class CompanyStatistics {

    constructor() {
        let self = this;
        self.logger = ClassLogger(self, true);

        if ($('[data-company-stats]').length === 0) {
            return;
        }
        self.init();
    }

    init() {
        let self = this;

        $('[data-company-stats]').each(function (i, item) {
            let $item = $(item);
            let companyId = $item.data('company-stats');
            const url = 'companies/' + companyId + '/stats';
            self.getStatistics(url, $item);
        });

    }

    getStatistics(url, $item) {
        let self = this;
        // Request Data
        Api.request('GET', url, '')
            .then(function (response) {

                if (typeof response.data !== 'undefined') {
                    // the array is defined and has at least one element
                    self.populateStatistics(response.data, $item);
                }

            }).catch(function (exception) {
                self.logger.error('Processor Error', exception);
                let error_message = 'Es trat ein Fehler auf!';
                if (typeof exception === 'object'
                    && typeof exception.responseJSON === 'object'
                    && typeof exception.responseJSON.error_code !== 'undefined'
                    && typeof exception.responseJSON.error_message === 'string'
                ) {
                    error_message = exception.responseJSON.error_message;
                }
                alert(error_message);

            });

    }

    populateStatistics(data, $item) {
        $item.find('[data-company-appointments]').html(data.appointments);

        data.applications.forEach(element => {
            if (element.applications > 0) {
                $('[data-jobid = ' + element.job_id + ']').find('.c-edit-jobs-list__info').after('<p class="c-edit-jobs-list__schedules"> Anzahl der erhaltenen 1-Klick-Bewerbungen:&nbsp;<strong>' + element.applications + '</strong></p>');
            }
        });
    }

}

export default new CompanyStatistics();
